export const updateObject = (oldObject, updatedProperties) => {
    return {
        ...oldObject,
        ...updatedProperties
    };
};


// WEBPACK FOOTER //
// src/store/utility.js